import FactorRow from "./FactorRow";

export default FactorRow;
